module.exports = __webpack_public_path__ + "static/media/Back_Arrow.5eec5e27.svg";